import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Suspense } from 'react';
import { Loading } from './components/Loading';

const console_log = process.env.REACT_APP_CONSOLE_LOG_DISABLE;

const App = lazy(() => import('./App'));
if (console_log === 'true') {
  console.log = function () {};
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <Suspense fallback={<Loading open={true} />}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Suspense>
  </Provider>,
);
